import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Head from '@/components/base/Head';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <Head
        title={t('legal.notfound_seo_title')}
        metas={[
          { name: 'robots', content: 'noindex' },
          { name: 'description', content: t('legal.notfound_seo_description') },
        ]}
      />
      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 py-16 overflow-hidden">
        <h1 className="absolute bottom-0 text-[7rem] sm:text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0 leading-none">
          404
        </h1>
        <div className="relative z-10 w-full max-w-md">
          <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mt-6">{t('legal.notfound_title')}</h1>
          <p className="mt-2 text-sm sm:text-base text-gray-400 font-mono break-all">{location.pathname}</p>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-500">{t('legal.notfound_subtitle')}</p>
        </div>
      </div>
    </>
  );
}
